import { render, staticRenderFns } from "./IncomeServices.vue?vue&type=template&id=ec353d56"
import script from "./IncomeServices.vue?vue&type=script&lang=js"
export * from "./IncomeServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports